import {ICoordinates} from '../../utils/location.formatter';
import {OnChanges} from '../../common/common.types';
import {mouse} from "d3-selection";

export interface IStationDetails {
  id?: number,
  code:string,
  name:string,
  region:string,
  basin:string
  country:string,
  location:ICoordinates
}


export default class StationDetailsEditController implements OnChanges {
  static $inject = ['$scope'];

  static DEFAULT_CENTER:ICoordinates = {latitude: 42.8746, longitude: 74.5698};
  static DEFAULT_ZOOM = 10;
  static DEFAULT_DETAILS:IStationDetails = {
    code: '',
    basin: '',
    region: '',
    name: '',
    country: '',
    location: StationDetailsEditController.DEFAULT_CENTER,
  };

  map:{
    center:ICoordinates,
    zoom:number,
    events:{
      [key:string]:(map:google.maps.Map,
                    eventName:string,
                    ...otherArgs:any[]) => void
    },
    control:{refresh?:(coords?:ICoordinates) => void},
    options?:google.maps.MapOptions,
  };

  marker:{id:string, coords:ICoordinates};

  stationDetails:IStationDetails;
  mutableStation:IStationDetails;
  onChange:(callbackArgs:{station:IStationDetails, isValid:boolean})=>void;

  constructor(private $scope:ng.IScope) {
    this.map = {
      center: StationDetailsEditController.DEFAULT_CENTER,
      zoom: StationDetailsEditController.DEFAULT_ZOOM,
      events: {
        click: (map:any, eventName:string,
            [mouseEvent]:[google.maps.MouseEvent]) => {
          this.onMapClick(mouseEvent)
        }
      },
      control: {}
    };
    this.marker = {
      id: 'followMarker',
      coords: this.map.center
    };
  }

  preventMapRefresh = false;

  $onChanges() {
    this.mutableStation = this.stationDetails
        ? angular.copy(this.stationDetails)
        : angular.copy(StationDetailsEditController.DEFAULT_DETAILS);
    this.marker.coords = this.mutableStation.location;
    if (this.map.control.refresh && !this.preventMapRefresh) {
      this.map.control.refresh(this.mutableStation.location);
    }

    this.preventMapRefresh = false;

    if (this.form) {
      this.form.$setPristine();
      this.form.$setUntouched();
    }
  }

  private onLocationInputFieldChange() {

    this.notifyChange();

    if (this.map.control.refresh) {
        this.map.control.refresh(this.mutableStation.location);
    }

  }

  getMessages(formValue:ng.INgModelController):any {
    const errorsCopy = angular.copy(formValue.$error);
    errorsCopy.$pending = formValue.$pending;
    return errorsCopy;
  }

  private get form():ng.IFormController {
    return this.$scope['stationForm'] || null;
  }

  private onMapClick(mouseEvent:google.maps.MouseEvent) {

    const loc = mouseEvent.latLng;
    this.marker.coords = {
      latitude: loc.lat(),
      longitude: loc.lng()
    };
    this.mutableStation.location = this.marker.coords;

    this.preventMapRefresh = true;

    this.$scope.$applyAsync();
    this.notifyChange();



  };

  private notifyChange() {
    if (this.onChange) {
      this.onChange({station: this.mutableStation, isValid: this.form.$valid});
    }
  }
}



/** WEBPACK FOOTER **
 ** ./app/meteostation/details/edit.controller.ts
 **/